<template>
  <div v-show="isShow" class="update-progress-bar">
    <div>
      <img :src="require('@/assets/img/vertical_logo.svg')" />
      <div class="bar">
        <div class="h-100" :style="`width: ${percent}%;`"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getNewestVersion,
  getOriginVersion,
  isHaveNewVersion,
} from '@/lib/base/checkVersion';
import {stage} from '@/constant/env';
import {CapacitorUpdater} from '@capgo/capacitor-updater';
import {SplashScreen} from '@capacitor/splash-screen';
import {App} from '@capacitor/app';
import {Device} from '@capacitor/device';

export default {
  data() {
    return {
      isChecking: false,
      isShow: false,
      percent: 0,
      bundle: null,
    };
  },
  computed: {
    cdn() {
      return this.$store.state.env.cdn;
    },
  },
  async created() {
    setTimeout(() => {
      SplashScreen.hide();
    }, 1500);

    CapacitorUpdater.addListener('download', (e) => {
      if (this.isShow) {
        this.percent = Math.floor(e.percent * 0.85);
      }
    });

    CapacitorUpdater.addListener('downloadComplete', () => {
      this.percent = 95;
    });

    CapacitorUpdater.addListener('downloadFailed', () => {
      this.$Message.error('Error: downloadFailed');
    });
    CapacitorUpdater.notifyAppReady();
    App.addListener('appStateChange', async (state) => {
      if (state.isActive && !this.isShow) await this.checkVersion();
    });
    await this.checkVersion();
  },
  methods: {
    async getOriginVersion() {
      return getOriginVersion();
    },
    async checkVersion() {
      const info = await Device.getInfo();
      if (info.platform === 'web') return;
      if (this.isChecking) return;
      this.isChecking = true;
      const timers = [];
      try {
        const originVersion = await this.getOriginVersion();
        const newestVersion = await getNewestVersion();
        const isHaveNew = isHaveNewVersion(originVersion, newestVersion);
        if (isHaveNew) {
          this.isShow = true;
          const url = `${this.cdn}dist/${stage}/${newestVersion}.zip`;
          this.bundle = await CapacitorUpdater.download({
            url,
            version: newestVersion,
          });
          this.percent = 98;
          if (this.bundle) {
            const info = await Device.getInfo();
            if (info.platform === 'ios') {
              timers.push(
                setTimeout(() => {
                  if (this.isShow) window.location.reload();
                }, 10000)
              );
              timers.push(
                setTimeout(() => {
                  if (this.isShow)
                    this.$alert(this.$t('更新完成，請手動關閉並重新打開 App'));
                }, 20000)
              );
              await CapacitorUpdater.set(this.bundle);
            } else {
              await CapacitorUpdater.next(this.bundle);
              await this.$alert(this.$t('更新完成，請重新啟動 App'));
              App.exitApp();
            }
          }
        }
      } catch (error) {
        try {
          await this.$alert(
            this.$t('更新未完成，請檢查網路連線後，重新啟動 APP 再試一次')
          );
          App.exitApp();
        } catch {
          // ignore
        }
      }
      this.isChecking = false;
      timers.forEach(clearTimeout);
    },
  },
};
</script>

<style lang="scss" scoped>
.update-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  background: $bgsection;
  width: 100%;
  height: 100%;
  display: flex;
  & > * {
    margin: auto;
    display: flex;
    width: 200px;
    flex-direction: column;
    align-items: center;
    gap: $spacing-s;
  }
  img {
    width: 130px;
    height: 130px;
  }
  .bar {
    width: 160px;
    height: 10px;
    background: $font-grayscale-3;
    overflow: hidden;
    border-radius: 10px;
    & > * {
      background: $accent;
    }
  }
}
</style>
